export default {
  id: "productComparison",
  name: "Product Comparison",
  description: "",
  member: "Product.name",
  report: {
    name: "Product Comparison",
    chartType: "",
    template: "product-comparison",
    member: "Product.name",
    config: {
      member: "Product.name",
      dataType: "single",
      dataSet: "Product",
      measures: [],
      dimensions: [],
      sort: {
        direction: null,
        by: null,
      },
      filters: [],
      compare: false,
      limit: "100",
      rowTotals: false,
      stacked: false,
      points: false,
      colorTheme: "default",
      applyDateRangeFilter: true,
      filterDateRange: true,
    },
  },
};
